<template>
  <Split v-model="splitValue">
    <div slot="left" :style="'padding: 10px 20px 10px 10px;overflow-y:auto;height:100%'">
      <Tree :data="carGroupTreeData" :load-data="getCarGroupTreeChildrenData" :render="renderContent"
            class="demo-tree-render" :height="100"></Tree>
    </div>
    <div slot="right" style="padding: 10px 20px 10px 10px;">
      <div>
        <!-- 右键 -->
        <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
        <!-- 搜索 -->
        <div style="padding-bottom: 3px;">
          <!--<Input size="small" v-model="searchMsg" placeholder="搜索" style="width: 180px;" :disabled="isLoading" />-->
          <Select v-model="searchMsg" size="small" filterable remote :remote-method="getSearchOption"
                  :loading="isLoading" style="width: 180px;" clearable>
            <Option v-for="(option, index) in SearchResultData" :value="option" :key="index">{{option}}</Option>
          </Select>
          <Button type="primary" size="small" style="margin-left:3px;" :disabled="listLoadding || isLoading"
                  @click="onFind">查询
          </Button>
        </div>
        <!-- 报表主页面 -->
        <div style="width: 100%;">
          <Table
            border
            size="small"
            :columns="columns"
            :data="data"
            highlight-row
            ref="table"
            @on-sort-change="onSortChange"
            @contextmenu.prevent.native="onTableRightClick($event)"
            :height="tableHeight"
          ></Table>
        </div>
        <!-- 蒙版 -->
        <div class="mb" v-if="listLoadding"></div>
        <!-- 分页控件 -->
        <Page
          :total="totalElements"
          :page-size="pagesize"
          :show-total="true"
          :current="pageIndex"
          @on-change="setPage"
          show-elevator
          style="text-align:right;margin-top:10px"
        />
        <!-- 自定义显示列 -->
        <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                                 v-model="webTableColumnsModal"></web-table-columns-modal>
        <!-- 分析设置：车辆 -->
        <Modal v-model="isShowSettingModal" title="分析设置" @on-ok="saveChange" @on-cancel="cancelChange" :loading="true">
          <div class="" slot="footer">
            <Button type="text" @click="cancelChange">取消</Button>
            <Button type="primary" :loading="isShowSettingModalLoading" @click="saveChange">确定</Button>
          </div>

          <Tabs size="small" style="margin:-10px -10px -10px -10px;">
            <!-- 超速 -->
            <TabPane label="超速">
              <Form
                ref="formSpeenLimitField"
                :model="formSpeenLimitField"
                :rules="formSpeenLimitValidate"
                :label-width="80"
                @on-validate="onSpeenLimitValidate"
              >
                <FormItem label="车牌号" prop="registrationNum" style="margin:0px;">
                  <Input type="text" v-model="formSpeenLimitField.registrationNum" readonly size="small"></Input>
                </FormItem>
                <FormItem label="车架号" prop="vin" style="margin:0px;">
                  <Input type="text" v-model="formSpeenLimitField.vin" readonly size="small"></Input>
                </FormItem>
                <FormItem label="主机号" prop="terminalNum" style="margin:0px;">
                  <Input type="text" v-model="formSpeenLimitField.terminalNum" readonly size="small"></Input>
                </FormItem>
                <FormItem
                  label="速度设置"
                  prop="speedLimit"
                  :style="formSpeenLimitValidateResult.speedLimit?'margin:0px;':'' + ''"
                >
                  <Input type="text" v-model.number="formSpeenLimitField.speedLimit" size="small"></Input>
                </FormItem>
              </Form>
            </TabPane>
            <!-- 车辆：进出区域 -->
            <TabPane label="进出区域">
              <Form
                ref="formLocalAlarmField"
                :model="formLocalAlarmField"
                :rules="formLocalAlarmValidate"
                :label-width="80"
                @on-validate="onLocalAlarmValidate"
              >
                <FormItem label="车牌号" prop="registrationNum" style="margin:0px;">
                  <Input type="text" v-model="formLocalAlarmField.registrationNum" readonly size="small"></Input>
                </FormItem>
                <FormItem label="车架号" prop="vin" style="margin:0px;">
                  <Input type="text" v-model="formLocalAlarmField.vin" readonly size="small"></Input>
                </FormItem>
                <FormItem label="主机号" prop="terminalNum" style="margin:0px;">
                  <Input type="text" v-model="formLocalAlarmField.terminalNum" readonly size="small"></Input>
                </FormItem>
                <FormItem label="绑定区域" prop="localalarmlimit" style="margin:0px;">
                  <Select
                    v-model="formLocalAlarmField.localalarmlimit"
                    multiple
                    filterable
                    remote
                    size="small"
                    transfer
                    :remote-method="formLocalAlarmFieldLocalalarmlimitRemote"
                    :loading="formLocalAlarmField.localalarmlimitLoading"
                  >
                    <Option
                      v-for="(option, index) in formLocalAlarmField.localalarmlimitOptions"
                      :value="option.value"
                      :key="index"
                    >{{option.label}}
                    </Option>
                  </Select>
                </FormItem>
                <FormItem label="报警类型" prop="type" style="margin:0px;">
                  <Select v-model="formLocalAlarmField.type" transfer size="small">
                    <Option :value="2">进出</Option>
                    <Option :value="0">进入</Option>
                    <Option :value="1">离开</Option>
                  </Select>
                </FormItem>
              </Form>
            </TabPane>
            <TabPane label="超时停车">
              <Form
                ref="formTimeoutParkingField"
                :model="formTimeoutParkingField"
                :rules="formLocalAlarmValidate"
                :label-width="120"
                @on-validate="onTimeoutParkingValidate"
              >
                <FormItem label="车牌号" prop="registrationNum" style="margin:0px;">
                  <Input type="text" v-model="formTimeoutParkingField.registrationNum" readonly size="small"></Input>
                </FormItem>
                <FormItem label="车架号" prop="vin" style="margin:0px;">
                  <Input type="text" v-model="formTimeoutParkingField.vin" readonly size="small"></Input>
                </FormItem>
                <FormItem label="主机号" prop="terminalNum" style="margin:0px;">
                  <Input type="text" v-model="formTimeoutParkingField.terminalNum" readonly size="small"></Input>
                </FormItem>
                <FormItem label="停车时长（毫秒）" prop="durationlimit" style="margin:0px;">
                  <Input type="number" number min="0" v-model="formTimeoutParkingField.durationlimit"
                         size="small"></Input>
                </FormItem>
              </Form>
            </TabPane>
            <TabPane label="ACC开关">
              <Form
                ref="formACCopenField"
                :model="formACCopenField"
                :rules="formACCopenValidate"
                :label-width="80"
                @on-validate="onACCopenValidate"
              >
                <FormItem label="车牌号" prop="registrationNum" style="margin:0px;">
                  <Input type="text" v-model="formACCopenField.registrationNum" readonly size="small"></Input>
                </FormItem>
                <FormItem label="车架号" prop="vin" style="margin:0px;">
                  <Input type="text" v-model="formACCopenField.vin" readonly size="small"></Input>
                </FormItem>
                <FormItem label="主机号" prop="terminalNum" style="margin:0px;">
                  <Input type="text" v-model="formACCopenField.terminalNum" readonly size="small"></Input>
                </FormItem>
                <FormItem label="acc开关" prop="switchtype" style="margin:0px;">
                  <i-switch size="small" v-model="formACCopenField.switchtype"/>
                </FormItem>
              </Form>
            </TabPane>
            <TabPane label="区域限速">
              <Form
                ref="formSpeedLimitAreaField"
                :model="formSpeedLimitAreaField"
                :rules="formSpeedLimitAreaValidate"
                :label-width="120"
                @on-validate="onSpeedLimitAreaValidate"
              >
                <FormItem label="车牌号" prop="registrationNum" style="margin:0px;">
                  <Input type="text" v-model="formSpeedLimitAreaField.registrationNum" readonly size="small"></Input>
                </FormItem>
                <FormItem label="车架号" prop="vin" style="margin:0px;">
                  <Input type="text" v-model="formSpeedLimitAreaField.vin" readonly size="small"></Input>
                </FormItem>
                <FormItem label="主机号" prop="terminalNum" style="margin:0px;">
                  <Input type="text" v-model="formSpeedLimitAreaField.terminalNum" readonly size="small"></Input>
                </FormItem>
                <FormItem label="设置类型" prop="speedlimitname" style="margin:0px;">
                  <Select
                    style="width:340px;margin-right:8px;"
                    v-model="formSpeedLimitAreaField.speedlimitname"
                    transfer
                    size="small"
                    @on-change="formSpeedLimitAreaFieldSpeedlimitnameChange"
                  >
                    <Option
                      v-for="(option, index) in formSpeedLimitAreaField.settings"
                      :value="option.speedlimitname"
                      :key="index"
                    >{{option.speedlimitname}}
                    </Option>
                  </Select>
                  <Button type="primary" size="small" @click="formSpeedLimitAreaFieldSpeedlimitnameAdd">新增</Button>
                </FormItem>
                <FormItem label="绑定区域" prop="localalarmlimit" style="margin:0px;">
                  <Select
                    v-model="formSpeedLimitAreaField.localalarmlimit"
                    multiple
                    filterable
                    remote
                    transfer
                    size="small"
                    :remote-method="formSpeedLimitAreaFieldLocalalarmlimitRemote"
                    :loading="formSpeedLimitAreaField.localalarmlimitLoading"
                  >
                    <Option
                      v-for="(option, index) in formSpeedLimitAreaField.localalarmlimitOptions"
                      :value="option.value"
                      :key="index"
                    >{{option.label}}
                    </Option>
                  </Select>
                </FormItem>
                <FormItem label="限制速度" prop="speedlimit" style="margin:0px;">
                  <Input type="number" number min="0" v-model="formSpeedLimitAreaField.speedlimit" size="small"></Input>
                </FormItem>
              </Form>
            </TabPane>
            <TabPane label="离线报警">
              <Form
                ref="formVehicleOfflineField"
                :model="formVehicleOfflineField"
                :rules="formVehicleOfflineValidate"
                :label-width="120"
                @on-validate="onVehicleOfflineValidate"
              >
                <FormItem label="车牌号" prop="registrationNum" style="margin:0px;">
                  <Input type="text" v-model="formVehicleOfflineField.registrationNum" readonly size="small"></Input>
                </FormItem>
                <FormItem label="车架号" prop="vin" style="margin:0px;">
                  <Input type="text" v-model="formVehicleOfflineField.vin" readonly size="small"></Input>
                </FormItem>
                <FormItem label="主机号" prop="terminalNum" style="margin:0px;">
                  <Input type="text" v-model="formVehicleOfflineField.terminalNum" readonly size="small"></Input>
                </FormItem>
                <FormItem label="天数" prop="typelimit" style="margin:0px;">
                  <Input type="number" number min="0" v-model="formVehicleOfflineField.typelimit" size="small"></Input>
                </FormItem>
                <!--
                <FormItem label="报警类型" prop="type" style="margin:0px;">
                    <Select v-model="formVehicleOfflineField.typelimit" transfer size="small">
                        <Option :value="2">报警</Option>
                        <Option :value="0">离线</Option>
                        <Option :value="1">上线</Option>
                    </Select>
                </FormItem>
                -->
              </Form>
            </TabPane>
            <!--            <TabPane label="设置7"></TabPane>-->
            <!--            <TabPane label="设置8"></TabPane>-->
            <!--            <TabPane label="设置9"></TabPane>-->
            <!--            <TabPane label="设置10"></TabPane>-->
          </Tabs>
        </Modal>

        <!-- 分析设置：分组 -->
        <Modal v-model="isShowGroupSettingModal" title="分析设置" :loading="true">
          <div class="" slot="footer">
            <Button type="text" @click="groupCancelChange">取消</Button>
            <Button type="primary" :loading="isShowGroupSettingModalLoading" @click="groupSaveChange">确定</Button>
          </div>
          <Tabs size="small" style="margin:-10px -10px -10px -10px;">
            <!-- 超速 -->
            <TabPane label="超速">
              <Form
                ref="formGroupSpeedLimitField"
                :model="formGroupSpeedLimitField"
                :rules="formGroupSpeedLimitValidate"
                :label-width="80"
                @on-validate="onGroupSpeedLimitValidate"
              >
                <FormItem label="分组名称" prop="name" style="margin:0px;">
                  <Input type="text" v-model="formGroupSpeedLimitField.name" readonly size="small"></Input>
                </FormItem>
                <FormItem label="速度设置" prop="speedLimit"
                          :style="formGroupSpeedLimitValidateResult.speedLimit?'margin:0px;':'' + ''">
                  <Input type="text" v-model.number="formGroupSpeedLimitField.speedLimit" size="small"></Input>
                </FormItem>
              </Form>
            </TabPane>
            <!-- 车辆：进出区域 -->
            <TabPane label="进出区域">
              <Form
                ref="formGroupLocalAlarmField"
                :model="formGroupLocalAlarmField"
                :rules="formGroupLocalAlarmValidate"
                :label-width="80"
                @on-validate="onGroupLocalAlarmValidate"
              >
                <FormItem label="分组名称" prop="name" style="margin:0px;">
                  <Input type="text" v-model="formGroupLocalAlarmField.name" readonly size="small"></Input>
                </FormItem>
                <FormItem label="绑定区域" prop="localalarmlimit" style="margin:0px;">
                  <Select
                    v-model="formGroupLocalAlarmField.localalarmlimit"
                    multiple
                    filterable
                    size="small"
                    remote
                    transfer
                    :remote-method="formGroupLocalAlarmFieldLocalalarmlimitRemote"
                    :loading="formGroupLocalAlarmField.localalarmlimitLoading"
                  >
                    <Option
                      v-for="(option, index) in formGroupLocalAlarmField.localalarmlimitOptions"
                      :value="option.value"
                      :key="index"
                    >{{option.label}}
                    </Option>
                  </Select>
                </FormItem>
                <FormItem label="报警类型" prop="type" style="margin:0px;">
                  <Select v-model="formGroupLocalAlarmField.type" size="small" transfer>
                    <Option :value="2">进出</Option>
                    <Option :value="0">进入</Option>
                    <Option :value="1">离开</Option>
                  </Select>
                </FormItem>
              </Form>
            </TabPane>
            <TabPane label="超时停车">
              <Form
                ref="formGroupTimeoutParkingField"
                :model="formGroupTimeoutParkingField"
                :rules="formGroupLocalAlarmValidate"
                :label-width="120"
                @on-validate="onGroupTimeoutParkingValidate"
              >
                <FormItem label="分组名称" prop="name" style="margin:0px;">
                  <Input type="text" v-model="formGroupTimeoutParkingField.name" readonly size="small"></Input>
                </FormItem>
                <FormItem label="停车时长（毫秒）" prop="durationlimit" style="margin:0px;">
                  <Input type="number" number min="0" v-model="formGroupTimeoutParkingField.durationlimit"
                         size="small"></Input>
                </FormItem>
              </Form>
            </TabPane>
            <TabPane label="ACC开关">
              <Form
                ref="formGroupACCopenField"
                :model="formGroupACCopenField"
                :rules="formGroupACCopenValidate"
                :label-width="80"
                @on-validate="onGroupACCopenValidate"
              >
                <FormItem label="分组名称" prop="name" style="margin:0px;">
                  <Input type="text" v-model="formGroupACCopenField.name" readonly size="small"></Input>
                </FormItem>
                <FormItem label="acc开关" prop="switchtype" style="margin:0px;">
                  <i-switch size="small" v-model="formGroupACCopenField.switchtype"/>
                </FormItem>
              </Form>
            </TabPane>
            <TabPane label="区域限速">
              <Form
                ref="formGroupSpeedLimitAreaField"
                :model="formGroupSpeedLimitAreaField"
                :rules="formGroupSpeedLimitAreaValidate"
                :label-width="120"
                @on-validate="onGroupSpeedLimitAreaValidate"
              >
                <FormItem label="分组名称" prop="name" style="margin:0px;">
                  <Input type="text" v-model="formGroupSpeedLimitAreaField.name" readonly size="small"></Input>
                </FormItem>
                <FormItem label="设置类型" prop="speedlimitname" style="margin:0px;">
                  <Select
                    style="width:340px;margin-right:8px;"
                    v-model="formGroupSpeedLimitAreaField.speedlimitname"
                    transfer
                    size="small"
                    @on-change="formGroupSpeedLimitAreaFieldSpeedlimitnameChange"
                  >
                    <Option
                      v-for="(option, index) in formGroupSpeedLimitAreaField.settings"
                      :value="option.speedlimitname"
                      :key="index"
                    >{{option.speedlimitname}}
                    </Option>
                  </Select>
                  <Button type="primary" size="small" @click="formGroupSpeedLimitAreaFieldSpeedlimitnameAdd">新增</Button>
                </FormItem>
                <FormItem label="绑定区域" prop="localalarmlimit" style="margin:0px;">
                  <Select
                    v-model="formGroupSpeedLimitAreaField.localalarmlimit"
                    multiple
                    filterable
                    remote
                    size="small"
                    transfer
                    :remote-method="formGroupSpeedLimitAreaFieldLocalalarmlimitRemote"
                    :loading="formGroupSpeedLimitAreaField.localalarmlimitLoading"
                  >
                    <Option
                      v-for="(option, index) in formGroupSpeedLimitAreaField.localalarmlimitOptions"
                      :value="option.value"
                      :key="index"
                    >{{option.label}}
                    </Option>
                  </Select>
                </FormItem>
                <FormItem label="限制速度" prop="speedlimit" style="margin:0px;">
                  <Input type="number" number min="0" v-model="formGroupSpeedLimitAreaField.speedlimit"
                         size="small"></Input>
                </FormItem>
              </Form>
            </TabPane>
            <TabPane label="离线报警">
              <Form
                ref="formGroupVehicleOfflineField"
                :model="formGroupVehicleOfflineField"
                :rules="formGroupVehicleOfflineValidate"
                :label-width="120"
                @on-validate="onGroupVehicleOfflineValidate"
              >
                <FormItem label="分组名称" prop="name" style="margin:0px;">
                  <Input type="text" v-model="formGroupVehicleOfflineField.name" readonly size="small"></Input>
                </FormItem>
                <FormItem label="天数" prop="typelimit" style="margin:0px;">
                  <Input type="number" number min="0" v-model="formGroupVehicleOfflineField.typelimit"
                         size="small"></Input>
                </FormItem>
                <!--
                <FormItem label="报警类型" prop="type" style="margin:0px;">
                    <Select v-model="formGroupVehicleOfflineField.typelimit" transfer size="small">
                        <Option :value="2">报警</Option>
                        <Option :value="0">离线</Option>
                        <Option :value="1">上线</Option>
                    </Select>
                </FormItem>
                -->
              </Form>
            </TabPane>
            <!--            <TabPane label="设置7"></TabPane>-->
            <!--            <TabPane label="设置8"></TabPane>-->
            <!--            <TabPane label="设置9"></TabPane>-->
            <!--            <TabPane label="设置10"></TabPane>-->
          </Tabs>
        </Modal>
      </div>
    </div>
  </Split>
</template>

<script>
import store from '../../store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'analysissetting',
  data: function () {
    return {
      isLoading: false, // 全局生效
      SearchResultData: [], // 搜索的下拉列表的数据
      // 分割大小
      splitValue: 0.3,
      // 左侧车辆分组列表树的数据
      carGroupTreeData: [],
      // 右侧车辆数据
      data: [],
      // 右侧表格列
      columns: [
        {
          title: 'id',
          key: 'id',
          width: 65,
          resizable: true,
          sortable: 'custom',
          align: 'center'
        },
        {
          title: '车牌号',
          key: 'registrationNum',
          width: 120,
          resizable: true,
          align: 'center'
        },
        {
          title: '车架号',
          key: 'vin',
          width: 180,
          resizable: true,
          align: 'center'
        },
        {
          title: '主机号',
          key: 'positioningDeviceInfosterminalNum',
          width: 140,
          resizable: true,
          sortable: 'custom',
          align: 'center',
          render: function (h, params) {
            let a = params.row.positioningDeviceInfos[0].terminalNum
            return h('div', a)
          }
        },
        {
          title: '起始时间',
          key: 'startDatetime',
          width: 180,
          resizable: true,
          sortable: 'custom',
          align: 'center',
          render: function (h, params) {
            if (params.row.startDatetime) {
              let d = new Date(params.row.startDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '结束时间',
          key: 'endDatetime',
          width: 180,
          resizable: true,
          sortable: 'custom',
          align: 'center',
          render: function (h, params) {
            if (params.row.endDatetime) {
              let d = new Date(params.row.endDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '创建时间',
          key: 'createDatetime',
          width: 180,
          resizable: true,
          sortable: 'custom',
          align: 'center',
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '分析时间',
          key: 'analyzeDatetime',
          width: 180,
          resizable: true,
          sortable: 'custom',
          align: 'center',
          render: function (h, params) {
            if (params.row.analyzeDatetime) {
              let d = new Date(params.row.analyzeDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '更新时间',
          key: 'updateDatetime',
          width: 180,
          resizable: true,
          sortable: 'custom',
          align: 'center',
          render: function (h, params) {
            if (params.row.updateDatetime) {
              let d = new Date(params.row.updateDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '处理备注',
          key: 'processRemark',
          width: 200,
          resizable: true,
          align: 'center'
        },
        {
          title: '历史处理备注',
          key: 'historyProcessRemark',
          width: 200,
          resizable: true,
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          width: 90,
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: this.isLoading
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.isLoading = true
                      // 设置表单默认项
                      let forms = [
                        'formSpeenLimitField', // 车辆超速表单
                        'formLocalAlarmField', // 车辆进出区域表单
                        'formTimeoutParkingField', // 车辆超时停车表单
                        'formACCopenField', // 车辆acc开关表单
                        'formSpeedLimitAreaField', // 车辆区域限速表单
                        'formVehicleOfflineField'// 车辆离线报警表单
                      ]
                      forms.forEach(item => {
                        this[item].registrationNum = params.row.registrationNum
                        this[item].vin = params.row.vin
                        this[item].terminalNum = params.row.positioningDeviceInfos[0].terminalNum
                      })

                      // 获取已经设置的数据
                      this.getOverspeedDetail(params.row.id),
                      this.getLocalAlarmDetail(params.row.id),
                      this.getTimeoutParkingDetail(params.row.id),
                      this.getACCopenDetail(params.row.id),
                      this.getSpeedLimitDetail(params.row.id),
                      this.getVehicleOfflineDetail(params.row.id),
                      this.isLoading = false
                      this.isShowSettingModal = true
                      // Promise.allSettled([
                      //   this.getOverspeedDetail(params.row.id),
                      //   this.getLocalAlarmDetail(params.row.id),
                      //   this.getTimeoutParkingDetail(params.row.id),
                      //   this.getACCopenDetail(params.row.id),
                      //   this.getSpeedLimitDetail(params.row.id),
                      //   this.getVehicleOfflineDetail(params.row.id)
                      // ]).then(res => {
                      //   this.isLoading = false
                      //   this.isShowSettingModal = true
                      // })
                    }
                  }
                },
                '分析设置'
              )
            ])
          }
        }
      ],
      // 表格高度
      tableHeight: 160,
      // 表格显示与分组
      totalElements: null,
      pagesize: 12,
      pageIndex: 1,
      listLoadding: false,
      webTableColumnsModal: false,
      // 表格右键
      menuList: [
        {
          title: '设置表格列',
          content: {}
        }
      ],
      // 右侧搜索
      searchMsg: '',
      // 是否显示设置模态框：车辆设置
      isShowSettingModal: false,
      isShowSettingModalLoading: false,
      // 是否显示设置模态框：分组设置
      isShowGroupSettingModal: false,
      isShowGroupSettingModalLoading: false,
      // 左侧当前选中的车辆分组id
      selectGroupId: null,

      // 表单数据：车辆设置-超速
      formSpeenLimitField: {
        registrationNum: '',
        vin: '',
        terminalNum: '',
        speedLimit: 0
      },
      formSpeenLimitValidateResult: {
        speedLimit: true
      },
      formSpeenLimitValidate: {
        speedLimit: [
          {
            required: true,
            type: 'number',
            message: '必须为数值',
            trigger: 'blur'
          }
        ]
      },
      // 表单数据：车辆设置-进出区域
      formLocalAlarmField: {
        registrationNum: '',
        vin: '',
        terminalNum: '',
        localalarmlimit: [],
        localalarmlimitLoading: false,
        localalarmlimitOptions: [],
        type: 2
      },
      formLocalAlarmValidateResult: {},
      formLocalAlarmValidate: {},
      // 表单数据：车辆设置-超时停车
      formTimeoutParkingField: {
        registrationNum: '',
        vin: '',
        terminalNum: '',
        durationlimit: 0
      },
      formTimeoutParkingValidateResult: {},
      formTimeoutParkingValidate: {},
      // 表单数据：车辆设置-acc开关
      formACCopenField: {
        registrationNum: '',
        vin: '',
        terminalNum: '',
        durationlimit: 0
      },
      formACCopenValidateResult: {},
      formACCopenValidate: {},
      // 表单数据：车辆设置-车辆区域限速定制设置
      formSpeedLimitAreaField: {
        registrationNum: '',
        vin: '',
        terminalNum: '',
        localalarmlimit: [],
        localalarmlimitLoading: false,
        localalarmlimitOptions: [],
        speedlimit: 0,
        speedlimitname: null,
        settings: []
      },
      formSpeedLimitAreaValidateResult: {},
      formSpeedLimitAreaValidate: {},
      // 表单数据：车辆设置-车辆离线报警定制设置
      formVehicleOfflineField: {
        registrationNum: '',
        vin: '',
        terminalNum: '',
        typelimit: 1
      },
      formVehicleOfflineValidateResult: {},
      formVehicleOfflineValidate: {},

      // 表单数据：分组设置-超速
      formGroupSpeedLimitField: {
        id: 0,
        name: '',
        speedLimit: 0
      },
      formGroupSpeedLimitValidateResult: {
        speedLimit: true
      },
      formGroupSpeedLimitValidate: {
        speedLimit: [
          {
            required: true,
            type: 'number',
            message: '必须为数值',
            trigger: 'blur'
          }
        ]
      },
      // 表单数据：分组设置-进出区域
      formGroupLocalAlarmField: {
        id: 0,
        name: '',
        localalarmlimit: [],
        localalarmlimitLoading: false,
        localalarmlimitOptions: [],
        type: 2
      },
      formGroupLocalAlarmValidateResult: {},
      formGroupLocalAlarmValidate: {},
      // 表单数据：分组设置-超时停车
      formGroupTimeoutParkingField: {
        id: 0,
        name: '',
        durationlimit: 0
      },
      formGroupTimeoutParkingValidateResult: {},
      formGroupTimeoutParkingValidate: {},
      // 表单数据：分组设置-acc开关
      formGroupACCopenField: {
        id: 0,
        name: '',
        durationlimit: 0
      },
      formGroupACCopenValidateResult: {},
      formGroupACCopenValidate: {},
      // 表单数据：分组设置-车辆区域限速定制设置
      formGroupSpeedLimitAreaField: {
        id: 0,
        name: '',
        localalarmlimit: [],
        localalarmlimitLoading: false,
        localalarmlimitOptions: [],
        speedlimit: 0,
        speedlimitname: null,
        settings: []
      },
      formGroupSpeedLimitAreaValidateResult: {},
      formGroupSpeedLimitAreaValidate: {},
      // 表单数据：分组设置-车辆离线报警定制设置
      formGroupVehicleOfflineField: {
        id: 0,
        name: '',
        typelimit: 1
      },
      formGroupVehicleOfflineValidateResult: {},
      formGroupVehicleOfflineValidate: {}
    }
  },
  mounted () {
    this.getCarGroupTreeData()

    this.$nextTick(() => {
      // 窗口的大小自适应
      this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 130
      window.onresize = () => {
        this.tableHeight =
            window.innerHeight - this.$refs.table.$el.offsetTop - 130
      }
    })

    // 初始化数据
    // this.getData(1)
  },
  methods: {
    // 设置左侧树的显示的render方法
    renderContent (h, { root, node, data }) {
      return h(
        'span',
        {
          style: {
            display: 'inline-block',
            width: '100%'
          }
        },
        [
          h('span', [
            h(
              'span',
              {
                on: {
                  // 点击加载数据
                  click: () => {
                    this.selectGroupId = data.id
                    this.getData(1)
                  }
                }
              },
              data.title
            )
          ]),
          h(
            'span',
            {
              style: {
                display: 'inline-block',
                float: 'right'
                // marginRight: '5px'
              }
            },
            [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: this.isLoading
                  },
                  style: {
                    display: data.id === null ? 'none' : 'block'
                  },
                  on: {
                    click: () => {
                      // 如果已经点击了，再次点击无效
                      if (this.isLoading) {
                        return
                      }
                      this.isLoading = true

                      // 设置表单默认项
                      let forms = [
                        'formGroupSpeedLimitField', // 车辆超速表单
                        'formGroupLocalAlarmField', // 车辆进出区域表单
                        'formGroupTimeoutParkingField', // 车辆超时停车表单
                        'formGroupACCopenField', // 车辆acc开关表单
                        'formGroupSpeedLimitAreaField', // 车辆区域限速表单
                        'formGroupVehicleOfflineField'// 车辆离线报警表单
                      ]
                      forms.forEach(item => {
                        this[item].id = data.id
                        this[item].name = data.name
                      })

                      // 获取已经设置的数据

                      this.getGroupOverspeedDetail(data.id),
                      this.getGroupLocalAlarmDetail(data.id),
                      this.getGroupTimeoutParkingDetail(data.id),
                      this.getGroupACCopenDetail(data.id),
                      this.getGroupSpeedLimitDetail(data.id),
                      this.getGroupVehicleOfflineDetail(data.id)
                      this.isShowGroupSettingModal = true
                      this.isLoading = false

                      // Promise.allSettled([
                      //   this.getGroupOverspeedDetail(data.id),
                      //   this.getGroupLocalAlarmDetail(data.id),
                      //   this.getGroupTimeoutParkingDetail(data.id),
                      //   this.getGroupACCopenDetail(data.id),
                      //   this.getGroupSpeedLimitDetail(data.id),
                      //   this.getGroupVehicleOfflineDetail(data.id)
                      // ]).then(res => {
                      //   console.log('打开弹框')
                      //   this.isShowGroupSettingModal = true
                      //   this.isLoading = false
                      // })
                    }
                  }
                },
                '分析设置'
              )
            ]
          )
        ]
      )
    },
    // 获取左侧车辆分组数据
    getCarGroupTreeData () {
      store
        .dispatch('VehicleInfoGroupServ_GetRootVehicleInfoGroups', {
          params: null,
          urlparams: null
        })
        .then(res => {
          this.carGroupTreeData = [
            {
              id: null,
              title: '未分组车辆'
            }
          ].concat(
            res.data.map(item => {
              return {
                id: item.id,
                title: item.name + '[分组数:' + item.groupCount + ',车辆数:' + item.groupVehicleInfoCount + ']',
                name: item.name,
                loading: false,
                children: []
              }
            })
          )
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取子节点
    getCarGroupTreeChildrenData (item, callback) {
      store
        .dispatch('VehicleInfoGroupServ_GetChildrenGroups', {
          params: {
            id: item.id
          },
          urlparams: null
        })
        .then(res => {
          let temp = res.data.map(item => {
            return {
              id: item.id,
              title:
                  item.name +
                  '[分组数:' +
                  item.groupCount +
                  ',车辆数:' +
                  item.groupVehicleInfoCount +
                  ']',
              name: item.name,
              loading: false,
              children: []
            }
          })
          callback(temp)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取搜索下拉的数据
    getSearchOption (query) {
      // 构建查询参数：根据车辆分组显示
      let queryPara = []
      if (this.selectGroupId) {
        queryPara.push(
          genQueryParam('vehicleInfoGroupId', 'EQ', this.selectGroupId)
        )
      } else {
        queryPara.push(genQueryParam('vehicleInfoGroupId', 'EQNULL', null))
      }

      this.isLoading = true
      store
        .dispatch('VehicleInfoServ_GetMyPage', {
          params: null,
          urlparams: {
            q: queryPara,
            keyword: query,
            p: 1
          }
        })
        .then(res => {
          this.SearchResultData =
              res.data.content.map(item => item.registrationNum)
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    // 获取数据
    getData (pageIndex) {
      // 构建查询参数：排序
      let sortParam = null
      if (this.sort) {
        sortParam = genSortParam(this.sort.field, this.sort.order)
      }
      // 构建查询参数：根据车辆分组显示
      let queryPara = []
      if (this.selectGroupId) {
        queryPara.push(
          genQueryParam('vehicleInfoGroupId', 'EQ', this.selectGroupId)
        )
      } else {
        queryPara.push(genQueryParam('vehicleInfoGroupId', 'EQNULL', null))
      }

      this.pageIndex = pageIndex
      this.listLoadding = true
      store
        .dispatch('VehicleInfoServ_GetMyPage', {
          params: null,
          urlparams: {
            q: queryPara,
            keyword: this.searchMsg,
            p: pageIndex,
            sort: sortParam
          }
        })
        .then(res => {
          this.listLoadding = false
          this.data = res.data.content
          this.totalElements = res.data.totalElements
          this.pagesize = res.data.pageable.pageSize
        })
        .catch(err => {
          console.log(err)
          this.listLoadding = false
        })
    },
    // 搜索
    onFind () {
      this.getData(1)
    },
    // 分页
    setPage (pageIndex) {
      this.getData(pageIndex)
    },
    // 右键菜单事件处理
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    // 表格右键回调
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(
        e,
        this.$el,
        -window.innerWidth * this.splitValue,
        0
      )
    },
    // 排序
    onSortChange ({ column, key, order }) {
      this.sort = null
      if (order !== 'normal') {
        this.sort = {
          field: key,
          order: order === 'asc'
        }
      }
      this.getData(1)
    },
    // 搜索区域的公共函数
    // query: 搜索信息
    // formName：绑定的表单
    // fieldName：绑定的字段
    searchMonitoredArea (query, formName, fieldName) {
      store
        .dispatch('MonitoredAreaServ_SearchByName', {
          params: {
            name: query
          },
          urlparams: null
        })
        .then(res => {
          // console.log(res)
          this[formName][fieldName] =
              res.data.map(
                item => {
                  return { label: item.name, value: item.id }
                }
              )
        })
        .catch(rea => {
          console.log(rea)
        })
    },
    // 通过一组id获取区域的
    getMonitoredAreaByIds (ids, formName, fieldName, cb) {
      Promise.allSettled(
        ids.map(item =>
          store
            .dispatch('MonitoredAreaServ_GetDetail', {
              params: { id: item },
              urlparams: null
            })))
        .then(res => {
          console.log(ids, formName, fieldName, res)
          let result = []
          res.forEach(item => {
            result = result.concat(item.status === 'fulfilled' ? item.value.data : [])
          })
          this[formName][fieldName] =
              result.map(i => {
                return { label: i.name, value: i.id }
              })
          if (cb) {
            cb()
          }
        })
    },

    /**
       * 车辆设置事件
       */
    // 提交表单数据：车辆-超速
    submitData () {
      // 车辆超速分析设置
      store
        .dispatch('OverspeedAnalysisRegulationServ_Datespeedlimit', {
          params: {
            terminalNum: this.formSpeenLimitField.terminalNum,
            speedlimit: this.formSpeenLimitField.speedLimit
          },
          urlparams: null
        })
        .then(res => {
          // 车辆进出区域设置
          if (this.formLocalAlarmField.localalarmlimit != null && this.formLocalAlarmField.localalarmlimit.length != 0) {
            return store.dispatch(
              'LocalAlarmAnalysisRegulationServ_Datelocalalarmlimit',
              {
                params: {
                  terminalNum: this.formLocalAlarmField.terminalNum,
                  localalarmlimit: this.formLocalAlarmField.localalarmlimit,
                  type: this.formLocalAlarmField.type
                },
                urlparams: null
              }
            )
          }
        })
        .then(res => {
          // 车辆超时停车设置
          return store.dispatch(
            'TimeoutParkingAnalysisRegulationServ_Datedurationlimit',
            {
              params: {
                terminalNum: this.formTimeoutParkingField.terminalNum,
                durationlimit: this.formTimeoutParkingField.durationlimit
              },
              urlparams: null
            }
          )
        })
        .then(res => {
          // 车辆acc开关设置
          return store.dispatch(
            'ACCopenAnalysisRegulationServ_Dateswitchtypelimit',
            {
              params: {
                terminalNum: this.formACCopenField.terminalNum,
                switchtype: this.formACCopenField.switchtype ? 0 : 1
              },
              urlparams: null
            }
          )
        })
        .then(res => {
          // 车辆区域限速定制设置
          if (this.formGroupSpeedLimitAreaField.localalarmlimit.length <= 0) {
            return new Promise((resolve, reject) => {
              resolve()
            })
          }
          return store.dispatch(
            'SpeedLimitAreaAnalysisRegulationServ_DatelocalalarmlimitAndspeedlimit',
            {
              params: {
                terminalNum: this.formSpeedLimitAreaField.terminalNum,
                speedlimitname: this.formSpeedLimitAreaField.speedlimitname,
                localalarmlimit: this.formSpeedLimitAreaField.localalarmlimit,
                speedlimit: this.formSpeedLimitAreaField.speedlimit
              },
              urlparams: null
            }
          )
        })
        .then(res => {
          // 车辆离线报警定制设置
          return store.dispatch(
            'VehicleOfflineAnalysisRegulationServ_Datetypelimit',
            {
              params: {
                terminalNum: this.formVehicleOfflineField.terminalNum,
                typelimit: this.formVehicleOfflineField.typelimit
              },
              urlparams: null
            }
          )
        })
        .then(res => {
          this.$Message.success('提交成功')
          this.onFind()
          this.isShowSettingModal = false
        })
        .catch(err => {
          console.log(err)
          this.$Message.error(err)
        })
        .finally(() => {
          this.isShowSettingModalLoading = false
        })
    },
    // 验证表单：车辆-超速
    saveChange () {
      this.isShowSettingModalLoading = true
      this.$refs['formSpeenLimitField'].validate(valid => {
        if (!valid) {
          this.$Message.error('表单验证失败')
          this.isShowSettingModalLoading = false
        } else {
          this.submitData()
        }
      })
    },
    // 取消验证：车辆
    cancelChange () {
      this.$refs['formSpeenLimitField'].resetFields()
      this.isShowSettingModal = false
    },
    // 选择车辆区域限速设置的设置选项
    formSpeedLimitAreaFieldSpeedlimitnameChange (value) {
      let app = this
      this.formSpeedLimitAreaField.localalarmlimit = []
      this.formSpeedLimitAreaField.speedlimit = 0
      let temp =
          this.formSpeedLimitAreaField
            .settings
            .filter(item => item.speedlimitname === value)
      if (temp.length === 1) {
        let temp2 = JSON.parse(temp[0].localalarmlimit)

        this.formSpeedLimitAreaField.speedlimit = temp[0].speedlimit
        if (temp2.length >= 1) {
          this.getMonitoredAreaByIds(
            temp2,
            'formSpeedLimitAreaField',
            'localalarmlimitOptions',
            function () {
              app.formSpeedLimitAreaField.localalarmlimit = temp2
            })
        }
      }
    },
    // 添加车辆区域限速设置的设置选项
    formSpeedLimitAreaFieldSpeedlimitnameAdd () {
      let addName = '设置' + (this.formSpeedLimitAreaField.settings.length + 1)
      this.formSpeedLimitAreaField.settings =
          this.formSpeedLimitAreaField.settings.concat({ speedlimit: 0, localalarmlimit: '[]', speedlimitname: addName })
      this.formSpeedLimitAreaField.speedlimitname = addName
      this.formSpeedLimitAreaFieldSpeedlimitnameChange(addName)
    },
    // 车辆验证结果-超速
    onSpeenLimitValidate (prop, status, error) {
      this.formSpeenLimitValidateResult[prop] = status
    },
    // 车辆验证结果-进出区域
    onLocalAlarmValidate () {
    },
    // 车辆验证结果-acc开关
    onACCopenValidate () {
    },
    // 车辆验证结果-超时停车
    onTimeoutParkingValidate () {
    },
    // 车辆验证结果-区域速度限制
    onSpeedLimitAreaValidate () {
    },
    // 车辆验证结果-车辆离线报警
    onVehicleOfflineValidate () {
    },
    // 车辆进出区域：区域搜索
    formLocalAlarmFieldLocalalarmlimitRemote (query) {
      this.searchMonitoredArea(query, 'formLocalAlarmField', 'localalarmlimitOptions')
    },
    // 车辆区域限速：区域搜索-
    formSpeedLimitAreaFieldLocalalarmlimitRemote (query) {
      this.searchMonitoredArea(query, 'formSpeedLimitAreaField', 'localalarmlimitOptions')
    },
    // 车辆离线报警：区域搜索
    formVehicleOfflineFieldLocalalarmlimitRemote (query) {
      this.searchMonitoredArea(query, 'formVehicleOfflineField', 'localalarmlimitOptions')
    },
    // 获取分组超速的API
    getOverspeedDetail (id) {
      return new Promise((resolve, reject) => {
        store
          .dispatch('OverspeedAnalysisRegulationServ_GetClientPage', {
            params: null,
            urlparams: {
              q: genQueryParam('vehicleInfoId', 'EQ', id)
            }
          })
          .then(res => {
            this.formSpeedLimitField.speedLimit = 0
            if (res.data.content.length >= 1) {
              this.formSpeedLimitField.speedLimit = res.data.content[0].speedlimit
            }
          })
          .catch(rea => {
            console.log(rea)
          })
          .finally(() => {
            resolve()
          })
      })
    },
    // 获取已经设置的车辆进出区域数据
    getLocalAlarmDetail (id) {
      return new Promise((resolve, reject) => {
        store
          .dispatch('LocalAlarmAnalysisRegulationServ_GetClientPage', {
            params: null,
            urlparams: {
              q: genQueryParam('vehicleInfoId', 'EQ', id)
            }
          })
          .then(res => {
            // console.log(res)
            this.formLocalAlarmField.localalarmlimit = []
            this.formLocalAlarmField.type = 2

            if (res.data.content.length >= 1) {
              let localalarmlimit = JSON.parse(res.data.content[0].localalarmlimit)
              this.formLocalAlarmField.localalarmlimit = localalarmlimit
              this.formLocalAlarmField.type = res.data.content[0].type

              // 这里如果已经有设置了区域数据，则远程获取区域的信息列表
              if (localalarmlimit.length >= 1) {
                this.getMonitoredAreaByIds(localalarmlimit, 'formLocalAlarmField', 'localalarmlimitOptions')
              }
            }
          })
          .catch(rea => {
            console.log(rea)
          })
          .finally(() => {
            resolve()
          })
      })
    },
    // 获取车辆超时停车数据
    getTimeoutParkingDetail (id) {
      return new Promise((resolve, reject) => {
        store
          .dispatch('TimeoutParkingAnalysisRegulationServ_GetClientPage', {
            params: null,
            urlparams: {
              q: genQueryParam('vehicleInfoId', 'EQ', id)
            }
          })
          .then(res => {
            // console.log(res)
            this.formTimeoutParkingField.durationlimit = 0
            if (res.data.content.length >= 1) {
              this.formTimeoutParkingField.durationlimit = res.data.content[0].durationlimit
            }
          })
          .catch(rea => {
            console.log(rea)
          })
          .finally(() => {
            resolve()
          })
      })
    },
    // 获取车辆acc开关数据
    getACCopenDetail (id) {
      return new Promise((resolve, reject) => {
        store
          .dispatch('ACCopenAnalysisRegulationServ_GetClientPage', {
            params: null,
            urlparams: {
              q: genQueryParam('vehicleInfoId', 'EQ', id)
            }
          })
          .then(res => {
            // console.log(res)
            this.formACCopenField.switchtype = true
            if (res.data.content.length >= 1) {
              this.formACCopenField.switchtype = res.data.content[0].switchtype === 0
            }
          })
          .catch(rea => {
            console.log(rea)
          })
          .finally(() => {
            resolve()
          })
      })
    },
    // 获取车辆区域限速定制设置
    getSpeedLimitDetail (id) {
      return new Promise((resolve, reject) => {
        store
          .dispatch('SpeedLimitAreaAnalysisRegulationServ_GetClientPage', {
            params: null,
            urlparams: {
              q: genQueryParam('vehicleInfoId', 'EQ', id)
            }
          })
          .then(res => {
            // 这里的数组会返回2个（有多个数据，待解决）
            // console.log(res)
            this.formSpeedLimitAreaField.settings = res.data.content
          })
          .catch(rea => {
            console.log(rea)
          })
          .finally(() => {
            resolve()
          })
      })
    },
    // 获取车辆离线报警定制设置
    getVehicleOfflineDetail (id) {
      return new Promise((resolve, reject) => {
        store
          .dispatch('VehicleOfflineAnalysisRegulationServ_GetClientPage', {
            params: null,
            urlparams: {
              q: genQueryParam('vehicleInfoId', 'EQ', id)
            }
          })
          .then(res => {
            this.formVehicleOfflineField.typelimit = 0
            if (res.data.content.length >= 1) {
              this.formVehicleOfflineField.typelimit = res.data.content[0].typelimit
            }
          })
          .catch(rea => {
            console.log(rea)
          })
          .finally(() => {
            resolve()
          })
      })
    },

    /**
       * 车辆分组设置事件
       */
    submitGroupSettingData () {
      // 分组超速分析设置
      store
        .dispatch(
          'OverspeedAnalysisRegulationServ_DatevehicleInfoGroupspeedlimit',
          {
            params: {
              vehicleInfoGroupids: this.formGroupSpeedLimitField.id,
              speedlimit: this.formGroupSpeedLimitField.speedLimit
            },
            urlparams: null
          }
        )
        .then(res => {
          // 车辆进出区域设置
          if (this.formGroupLocalAlarmField.localalarmlimit != null && this.formGroupLocalAlarmField.localalarmlimit.length != 0) {
            return store.dispatch(
              'LocalAlarmAnalysisRegulationServ_DatevehicleInfoGrouplocalalarmlimit',
              {
                params: {
                  vehicleInfoGroupids: this.formGroupLocalAlarmField.id,
                  localalarmlimit: this.formGroupLocalAlarmField.localalarmlimit,
                  type: this.formGroupLocalAlarmField.type
                },
                urlparams: null
              }
            )
          }
        })
        .then(res => {
          // 车辆超时停车设置
          return store.dispatch(
            'TimeoutParkingAnalysisRegulationServ_DatevehicleInfoGroupdurationlimit',
            {
              params: {
                vehicleInfoGroupids: this.formGroupTimeoutParkingField.id,
                durationlimit: this.formGroupTimeoutParkingField.durationlimit
              },
              urlparams: null
            }
          )
        })
        .then(res => {
          // 车辆acc开关设置
          return store.dispatch(
            'ACCopenAnalysisRegulationServ_DatevehicleInfoGroupswitchtypelimit',
            {
              params: {
                vehicleInfoGroupids: this.formGroupACCopenField.id,
                switchtype: (this.formGroupACCopenField.switchtype ? 0 : 1)
              },
              urlparams: null
            }
          )
        })
        .then(res => {
          // 分组区域限速定制设置
          if (this.formGroupSpeedLimitAreaField.localalarmlimit.length <= 0) {
            return new Promise((resolve, reject) => {
              resolve()
            })
          }
          return store.dispatch(
            'SpeedLimitAreaAnalysisRegulationServ_DatevehicleInfoGrouplocalalarmlimitspeedlimit',
            {
              params: {
                vehicleInfoGroupids: this.formGroupSpeedLimitAreaField.id,
                localalarmlimit: this.formGroupSpeedLimitAreaField.localalarmlimit,
                speedlimit: this.formGroupSpeedLimitAreaField.speedlimit,
                speedlimitname: this.formGroupSpeedLimitAreaField.speedlimitname
              },
              urlparams: null
            }
          )
        })
        .then(res => {
          // 分组离线报警定制设置
          return store.dispatch(
            'VehicleOfflineAnalysisRegulationServ_DatevehicleInfoGrouptypelimit',
            {
              params: {
                vehicleInfoGroupids: this.formGroupVehicleOfflineField.id,
                typelimit: this.formGroupVehicleOfflineField.typelimit
              },
              urlparams: null
            }
          )
        })
        .then(res => {
          this.$Message.success('提交成功')
          this.isShowGroupSettingModal = false
        })
        .catch(err => {
          if (err) {
            console.log(err)
            this.$Message.error(err)
          }
        })
        .finally(() => {
          this.isShowGroupSettingModalLoading = false
        })
    },
    // 点击数节点显示改组下面的车辆
    groupSaveChange () {
      this.isShowGroupSettingModalLoading = true
      // 分组超速设置
      this.$refs['formGroupSpeedLimitField'].validate(valid => {
        if (!valid) {
          this.$Message.error('表单验证失败')
          this.isShowGroupSettingModalLoading = false
        } else {
          this.submitGroupSettingData()
        }
      })
    },
    // 车辆分组模态框取消
    groupCancelChange () {
      this.$refs['formGroupSpeedLimitField'].resetFields()
      this.isShowGroupSettingModal = false
    },
    // 选择车辆区域限速设置的设置选项
    formGroupSpeedLimitAreaFieldSpeedlimitnameChange (value) {
      let app = this
      this.formGroupSpeedLimitAreaField.localalarmlimit = []
      this.formGroupSpeedLimitAreaField.speedlimit = 0
      let temp =
          this.formGroupSpeedLimitAreaField
            .settings
            .filter(item => item.speedlimitname === value)
      if (temp.length === 1) {
        let temp2 = JSON.parse(temp[0].localalarmlimit)

        this.formGroupSpeedLimitAreaField.speedlimit = temp[0].speedlimit
        if (temp2.length >= 1) {
          this.getMonitoredAreaByIds(
            temp2,
            'formGroupSpeedLimitAreaField',
            'localalarmlimitOptions',
            function () {
              app.formGroupSpeedLimitAreaField.localalarmlimit = temp2
            })
        }
      }
    },
    // 添加车辆区域限速设置的设置选项
    formGroupSpeedLimitAreaFieldSpeedlimitnameAdd () {
      let addName = '设置' + (this.formGroupSpeedLimitAreaField.settings.length + 1)
      this.formGroupSpeedLimitAreaField.settings =
          this.formGroupSpeedLimitAreaField.settings.concat({
            speedlimit: 0,
            localalarmlimit: '[]',
            speedlimitname: addName
          })
      this.formGroupSpeedLimitAreaField.speedlimitname = addName
      this.formGroupSpeedLimitAreaFieldSpeedlimitnameChange(addName)
    },
    // 车辆分组验证结果-速度
    onGroupSpeedLimitValidate (prop, status, error) {
      this.formGroupSpeedLimitValidateResult[prop] = status
    },
    // 车辆分组验证结果-进出区域
    onGroupLocalAlarmValidate () {
    },
    // 车辆分组验证结果-acc开关
    onGroupACCopenValidate () {
    },
    // 车辆分组验证结果-超时停车
    onGroupTimeoutParkingValidate () {
    },
    // 车辆分组验证结果-区域速度限制
    onGroupSpeedLimitAreaValidate () {
    },
    // 车辆分组验证结果-车辆离线报警
    onGroupVehicleOfflineValidate () {
    },
    // 车辆分组进出区域：区域搜索
    formGroupLocalAlarmFieldLocalalarmlimitRemote (query) {
      this.searchMonitoredArea(query, 'formGroupLocalAlarmField', 'localalarmlimitOptions')
    },
    // 分组区域限速：区域搜索
    formGroupSpeedLimitAreaFieldLocalalarmlimitRemote (query) {
      this.searchMonitoredArea(query, 'formGroupSpeedLimitAreaField', 'localalarmlimitOptions')
    },
    // 分组离线报警：区域搜索
    formGroupVehicleOfflineFieldLocalalarmlimitRemote (query) {
      this.searchMonitoredArea(query, 'formGroupVehicleOfflineField', 'localalarmlimitOptions')
    },
    // 获取分组超速的API
    getGroupOverspeedDetail (id) {
      return new Promise((resolve, reject) => {
        store
          .dispatch('OverspeedAnalysisRegulationServ_GetClientPage', {
            params: null,
            urlparams: {
              q: genQueryParam('vehicleInfoGroupids', 'EQ', id)
            }
          })
          .then(res => {
            console.log(res, 'OverspeedAnalysisRegulationServ_GetClientPage')
            this.formGroupSpeedLimitField.speedLimit = 0
            if (res.data.content.length >= 1) {
              this.formGroupSpeedLimitField.speedLimit = res.data.content[0].speedlimit
            }
          })
          .catch(rea => {
            console.log(rea)
          })
          .finally(() => {
            resolve()
          })
      })
    },
    // 获取已经设置的车辆分组进出区域数据
    getGroupLocalAlarmDetail (id) {
      return new Promise((resolve, reject) => {
        store
          .dispatch('LocalAlarmAnalysisRegulationServ_GetClientPage', {
            params: null,
            urlparams: {
              q: genQueryParam('vehicleInfoGroupids', 'EQ', id)
            }
          })
          .then(res => {
            // console.log(res)
            this.formGroupLocalAlarmField.localalarmlimit = []
            this.formGroupLocalAlarmField.type = 2

            if (res.data.content.length >= 1) {
              let localalarmlimit = JSON.parse(res.data.content[0].localalarmlimit)
              this.formGroupLocalAlarmField.localalarmlimit = localalarmlimit
              this.formGroupLocalAlarmField.type = res.data.content[0].type

              // 这里如果已经有设置了区域数据，则远程获取区域的信息列表
              if (localalarmlimit.length >= 1) {
                this.getMonitoredAreaByIds(localalarmlimit, 'formGroupLocalAlarmField', 'localalarmlimitOptions')
              }
            }
          })
          .catch(rea => {
            console.log(rea)
          })
          .finally(() => {
            resolve()
          })
      })
    },
    // 获取车辆分组超时停车数据
    getGroupTimeoutParkingDetail (id) {
      return new Promise((resolve, reject) => {
        store
          .dispatch('TimeoutParkingAnalysisRegulationServ_GetClientPage', {
            params: null,
            urlparams: {
              q: genQueryParam('vehicleInfoGroupids', 'EQ', id)
            }
          })
          .then(res => {
            // console.log(res)
            this.formGroupTimeoutParkingField.durationlimit = 0
            if (res.data.content.length >= 1) {
              this.formGroupTimeoutParkingField.durationlimit = res.data.content[0].durationlimit
            }
          })
          .catch(rea => {
            console.log(rea)
          })
          .finally(() => {
            resolve()
          })
      })
    },
    // 获取车辆分组acc开关数据
    getGroupACCopenDetail (id) {
      return new Promise((resolve, reject) => {
        store
          .dispatch('ACCopenAnalysisRegulationServ_GetClientPage', {
            params: null,
            urlparams: {
              q: genQueryParam('vehicleInfoGroupids', 'EQ', id)
            }
          })
          .then(res => {
            // console.log(res)
            this.formGroupACCopenField.switchtype = true
            if (res.data.content.length >= 1) {
              this.formGroupACCopenField.switchtype = res.data.content[0].switchtype === 0
            }
          })
          .catch(rea => {
            console.log(rea)
          })
          .finally(() => {
            resolve()
          })
      })
    },
    // 获取车辆分组区域限速定制设置
    getGroupSpeedLimitDetail (id) {
      return new Promise((resolve, reject) => {
        store
          .dispatch('SpeedLimitAreaAnalysisRegulationServ_GetClientPage', {
            params: null,
            urlparams: {
              q: genQueryParam('vehicleInfoGroupids', 'EQ', id)
            }
          })
          .then(res => {
            /*
                  console.log(res)
                  this.formGroupSpeedLimitAreaField.localalarmlimit = []
                  this.formGroupSpeedLimitAreaField.speedlimit = 0

                  if (res.data.content.length >= 1) {
                    let localalarmlimit = JSON.parse(res.data.content[0].localalarmlimit)
                    this.formGroupSpeedLimitAreaField.localalarmlimit = localalarmlimit
                    this.formGroupSpeedLimitAreaField.speedlimit = res.data.content[0].speedlimit

                    // 这里如果已经有设置了区域数据，则远程获取区域的信息列表
                    if (localalarmlimit.length >= 1) {
                      this.getMonitoredAreaByIds(localalarmlimit, 'formGroupSpeedLimitAreaField', 'localalarmlimitOptions')
                    }
                  }
                  */
            this.formGroupSpeedLimitAreaField.settings = res.data.content
          })
          .catch(rea => {
            console.log(rea)
          })
          .finally(() => {
            resolve()
          })
      })
    },
    // 获取车辆分组离线报警定制设置
    getGroupVehicleOfflineDetail (id) {
      return new Promise((resolve, reject) => {
        store
          .dispatch('VehicleOfflineAnalysisRegulationServ_GetClientPage', {
            params: null,
            urlparams: {
              q: genQueryParam('vehicleInfoGroupids', 'EQ', id)
            }
          })
          .then(res => {
            this.formGroupVehicleOfflineField.typelimit = 0
            if (res.data.content.length >= 1) {
              this.formGroupVehicleOfflineField.typelimit = res.data.content[0].typelimit
            }
          })
          .catch(rea => {
            console.log(rea)
          })
          .finally(() => {
            resolve()
          })
      })
    }
  }
}
</script>

<style>
  .demo-tree-render .ivu-tree-title {
    width: 100%;
  }
</style>
